import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import LogIn from '@src/quince-site-integrated/src/templates/Auth/LogIn'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import Layout from '../layout'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(
    ctx,
    PAGE_PATH.LOG_IN,
    new URLSearchParams(ctx.query as Record<string, string>),
  )
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageLogIn(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      {props.pageData?.authenticationPage ? (
        <LogIn data={props.pageData} location={{ search: props.searchParams }} />
      ) : (
        <SomethingWentWrong />
      )}
    </Layout>
  )
}
